import { render, staticRenderFns } from "./tracker-organizations-by-economic-activity-labels.vue?vue&type=template&id=60cf3414&scoped=true&"
import script from "./tracker-organizations-by-economic-activity-labels.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-economic-activity-labels.vue?vue&type=script&lang=js&"
import style0 from "./tracker-organizations-by-economic-activity-labels.vue?vue&type=style&index=0&id=60cf3414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf3414",
  null
  
)

export default component.exports